define.alias("shared/utils/formatters/ig-post-from-basic-display", "calendar/utils/formatters/ig-post-from-basic-display");